import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content mb-sm" }
const _hoisted_2 = { class: "popup__controls" }
const _hoisted_3 = { class: "text-capitalize-first" }
const _hoisted_4 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    "hide-title": true,
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.config?.title), 1),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
            class: "btn popup__close"
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.config?.cancelTitle ?? _ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.onOkClick,
            class: "btn btn--accept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.config?.okTitle ?? _ctx.$t('button.ok')), 1)
            ]),
            _: 1
          }, 8, ["on-click"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}